import { BaseSyntheticEvent } from 'react';
import styled from 'styled-components';
import { PackagePrices } from 'types/join';

const AdditionalUsersWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.colors.siteBlackLight};
  border-radius: 4px;
  width: fit-content;
  height: 16px;
`;

const Button = styled.button<{ disabled?: boolean }>`
  background-color: ${props =>
    props.disabled ? props.theme.colors.white : props.theme.colors.darkGray};
  border: none;
  border-right: 1px solid ${props => props.theme.colors.siteBlackLight};
  border-left: 1px solid ${props => props.theme.colors.siteBlackLight};
  padding: 0 4px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 12px;
  color: ${props => (props.disabled ? props.theme.colors.grayDark : props.theme.colors.siteBlack)};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    border-left: none;
    border-radius: 2px 0 0 2px;
  }

  &:last-child {
    border-right: none;
    border-radius: 0 2px 2px 0;
  }
`;

const AdditionalUsersInput = styled.input`
  border: none;
  width: 18px;
  font-size: 10px;
  text-align: center;
  font-family: ${props => props.theme.fonts.montserratLight};
  outline: none;

  &:disabled {
    background-color: ${props => props.theme.colors.grayLight};
    color: ${props => props.theme.colors.grayDark};
  }
`;

type AdditionalUsersBoxProps = {
  isActive: boolean;
  numOfAdditionalUser: string;
  setNumber: (e: BaseSyntheticEvent, addonPackage: PackagePrices) => void;
  addon: PackagePrices;
};

export const AdditionalUsersBox = ({
  isActive,
  numOfAdditionalUser,
  setNumber,
  addon
}: AdditionalUsersBoxProps) => {
  const handleDecrement = (e: React.BaseSyntheticEvent, addon: PackagePrices) => {
    const currentValue = parseInt(numOfAdditionalUser) || 0;
    if (currentValue > 1) {
      e.target.value = (currentValue - 1).toString();
      setNumber(e, addon);
    }
  };

  const handleIncrement = (e: React.BaseSyntheticEvent, addon: PackagePrices) => {
    const currentValue = parseInt(numOfAdditionalUser) || 0;
    e.target.value = (currentValue + 1).toString();
    setNumber(e, addon);
  };

  return (
    <AdditionalUsersWrapper>
      <Button
        disabled={!isActive || parseInt(numOfAdditionalUser) <= 1}
        onClick={e => handleDecrement(e, addon)}
      >
        -
      </Button>
      <AdditionalUsersInput
        value={numOfAdditionalUser}
        onChange={e => setNumber(e, addon)}
        disabled={!isActive}
      />
      <Button disabled={!isActive} onClick={e => handleIncrement(e, addon)}>
        +
      </Button>
    </AdditionalUsersWrapper>
  );
};

export default AdditionalUsersBox;
